import React from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import useMediaQuery from '@mui/material/useMediaQuery';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import { colors } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PropTypes from 'prop-types';
import DownloadIcon from '@mui/icons-material/Download';


const Categories = ({mock,current}) => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });
  const renderContent = (title, version, links, icon, color) => (
    <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
      <Box
        component={Avatar}
        bgcolor={color[100]}
        color={color[900]}
        marginBottom={1}
        width={60}
        height={60}
      >
        {icon}
      </Box>
      <Typography variant={'h6'} fontWeight={700} align={'center'} gutterBottom>
        {title}
      </Typography>
      <Typography color={'text.secondary'} align={'center'}>
        Pipy {version} (latest)
      </Typography>
	  <Box style={{'paddingLeft':'10px','paddingTop':'20px'}}>
	  {links.map((item, i) => (
		<Box component={'a'} href={item.href} target="_blank"
			paddingY={0 / 2}
			paddingX={1}
			bgcolor={'#ececec'}
			borderRadius={2}
			style={{'marginRight':'10px'}}
			marginTop={2}
		>
			<DownloadIcon sx={{ color: 'common.black',fontSize:'0.8em',position:'relative',marginRight:'2px',top:3 }}/>
			<Typography
			  variant={'caption'}
			  fontWeight={700}
			  sx={{ color: 'common.black' }}
			>
			  {item.label}
			</Typography>
		</Box>
	  ))}
	  </Box>
    </Box>
  );

  return (
    <Box>
		  <Grid container spacing={4}  paddingTop={2} paddingBottom={2}>
			{Object.keys(mock).map((key) => (
			  (current==key||mock[key].version==0)?null:
			  <Grid item xs={12} md={4} key={key}>
					<Card
						sx={{
						borderTop: `2px solid ${mock[key].color[900]}`,
						borderTopLeftRadius: 0,
						borderTopRightRadius: 0,
						
						}}
					>
						<CardContent sx={{ padding: 3 }}>
						{renderContent(
							mock[key].title,
							mock[key].version,
							mock[key].links,
							mock[key].icon,
							mock[key].color,
						)}
						</CardContent>
					</Card>
			  </Grid>
			  
			))}
		  </Grid>
    </Box>
  );
};

Categories.propTypes = {
  mock: PropTypes.object,
  current: PropTypes.string,
};
export default Categories;
